import { render } from "./6.Products.vue?vue&type=template&id=336560d4&scoped=true"
import script from "./6.Products.vue?vue&type=script&lang=js"
export * from "./6.Products.vue?vue&type=script&lang=js"

import "./6.Products.vue?vue&type=style&index=0&id=336560d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336560d4"]])

export default __exports__